var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mx-auto",attrs:{"id":"app"}},[(_vm.products.length)?_c('ProductSlider',{attrs:{"products":_vm.products}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }